module.exports = __webpack_public_path__ + "img/startingbg.4da5c122.png";